import { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SeoHead from '../seo/SeoHead';
import { PAGES, BUSINESS } from '../seo/businessConfig';
import { pageBreadcrumbs, buildLodgingBusinessSchema } from '../seo/schema';

function Kontakt() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const page = PAGES.kontakt;
  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    `${BUSINESS.address.streetAddress}, ${BUSINESS.address.postalCode} ${BUSINESS.address.cityForSearch}`
  )}`;

  return (
    <div className="relative bg-primary-olive min-h-screen">
      <SeoHead
        title={page.title}
        description={page.description}
        keywords={page.keywords}
        path={page.path}
        jsonLd={[pageBreadcrumbs('kontakt'), buildLodgingBusinessSchema()]}
      />
      <Navbar />

      <main className="pt-32 md:pt-48 pb-20 px-6 md:px-12 max-w-5xl mx-auto">
        <header className="mb-12 md:mb-20">
          <h1 className="text-5xl md:text-7xl font-bold text-primary tracking-wide">
            Kontakt
            <span className="text-primary opacity-50">/</span>
          </h1>
          <p className="mt-4 text-primary text-lg md:text-xl max-w-2xl leading-relaxed">
            Zarezerwuj nocleg w agroturystyce Zacisze Czarna Owca — Brzeżanka koło Strzyżowa.
          </p>
        </header>

        <div
          className="bg-primary text-primary-bright rounded-xl shadow-2xl p-8 md:p-16 grid grid-cols-1 md:grid-cols-2 gap-12"
          itemScope
          itemType="https://schema.org/LodgingBusiness"
        >
          <meta itemProp="name" content={BUSINESS.legalName} />
          <div className="space-y-8 text-xl md:text-2xl">
            <div>
              <h2 className="text-sm font-thin uppercase tracking-widest opacity-70 mb-2">Telefon</h2>
              <p className="font-bold hover:text-primary-olive transition-colors">
                <a href={`tel:${BUSINESS.telephone}`} itemProp="telephone">
                  {BUSINESS.telephoneDisplay}
                </a>
              </p>
            </div>

            <div>
              <h2 className="text-sm font-thin uppercase tracking-widest opacity-70 mb-2">E-mail</h2>
              <p className="font-bold hover:text-primary-olive transition-colors">
                <a href={`mailto:${BUSINESS.email}`} itemProp="email">
                  {BUSINESS.email}
                </a>
              </p>
            </div>

            <div itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
              <h2 className="text-sm font-thin uppercase tracking-widest opacity-70 mb-2">Adres</h2>
              <p className="font-bold leading-snug">
                {BUSINESS.legalName}
                <br />
                <span itemProp="streetAddress">{BUSINESS.address.streetAddress}</span>
                <br />
                <span itemProp="postalCode">{BUSINESS.address.postalCode}</span>{' '}
                <span itemProp="addressLocality">{BUSINESS.address.addressLocality}</span>
                <br />
                <span itemProp="addressRegion">{BUSINESS.address.addressRegion}</span>, Polska
                <meta itemProp="addressCountry" content="PL" />
              </p>
              <p className="text-base mt-3 opacity-80 font-normal">
                Ok. 5 km od Strzyżowa · baza wypadowa na Podkarpacie i okolice Rzeszowa
              </p>
            </div>

            <div>
              <h2 className="text-sm font-thin uppercase tracking-widest opacity-70 mb-2">Zameldowanie</h2>
              <p className="font-bold text-lg">
                Check-in od {BUSINESS.checkinTime} · check-out do {BUSINESS.checkoutTime}
              </p>
            </div>
          </div>

          <div className="flex flex-col justify-center items-center md:items-end space-y-6">
            <p className="text-lg md:text-xl text-center md:text-right opacity-90 max-w-xs">
              Masz pytania lub chcesz zarezerwować termin bezpośrednio? Zadzwoń lub napisz — chętnie pomożemy.
            </p>
            <a
              href={mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-primary-bright text-primary font-bold px-6 py-3 rounded-sm hover:opacity-90 transition-opacity"
            >
              Pokaż na mapie Google
            </a>
            <iframe
              title="Mapa Zacisze Czarna Owca Brzeżanka Strzyżów"
              className="w-full h-56 md:h-64 rounded-lg border-0 mt-2"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              src={`https://maps.google.com/maps?q=${BUSINESS.geo.latitude},${BUSINESS.geo.longitude}&z=14&output=embed`}
            />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default Kontakt;
